
import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { TranslationText } from '@/components/i18n/TranslationText';
import { useTranslation } from 'react-i18next';

export default function TermsOfServicePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-gray-50 dark:from-gray-900 dark:to-gray-800">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="mb-8">
          <Button 
            variant="ghost" 
            onClick={() => navigate('/')}
            className="mb-4"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            <TranslationText i18nKey="backToHome">Back to Home</TranslationText>
          </Button>
          
          <h1 className="text-4xl font-bold mb-4">
            <TranslationText i18nKey="termsOfService">Terms of Service</TranslationText>
          </h1>
          
          <p className="text-muted-foreground">
            <TranslationText i18nKey="lastUpdated">Last updated: January 2024</TranslationText>
          </p>
        </div>
        
        <div className="prose prose-gray dark:prose-invert max-w-none space-y-8">
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              <TranslationText i18nKey="terms.acceptance">1. Acceptance of Terms</TranslationText>
            </h2>
            <p className="text-muted-foreground">
              <TranslationText i18nKey="terms.acceptanceText">
                By accessing and using Subtrackr, you accept and agree to be bound by the terms and provision of this agreement.
              </TranslationText>
            </p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              <TranslationText i18nKey="terms.useOfService">2. Use of Service</TranslationText>
            </h2>
            <p className="text-muted-foreground">
              <TranslationText i18nKey="terms.useOfServiceText">
                You may use our service for lawful purposes only. You agree not to use the service in any way that violates any applicable federal, state, local, or international law or regulation.
              </TranslationText>
            </p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              <TranslationText i18nKey="terms.userAccounts">3. User Accounts</TranslationText>
            </h2>
            <p className="text-muted-foreground">
              <TranslationText i18nKey="terms.userAccountsText">
                When you create an account with us, you must provide information that is accurate, complete, and current at all times. You are responsible for safeguarding the password and for all activities that occur under your account.
              </TranslationText>
            </p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              <TranslationText i18nKey="terms.dataProtection">4. Data Protection</TranslationText>
            </h2>
            <p className="text-muted-foreground">
              <TranslationText i18nKey="terms.dataProtectionText">
                We take data protection seriously. Your contract data is encrypted and stored securely. We will never share your data with third parties without your explicit consent.
              </TranslationText>
            </p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              <TranslationText i18nKey="terms.serviceAvailability">5. Service Availability</TranslationText>
            </h2>
            <p className="text-muted-foreground">
              <TranslationText i18nKey="terms.serviceAvailabilityText">
                We strive to maintain high availability of our service, but we do not guarantee that the service will be available at all times. We reserve the right to modify or discontinue the service with reasonable notice.
              </TranslationText>
            </p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              <TranslationText i18nKey="terms.limitation">6. Limitation of Liability</TranslationText>
            </h2>
            <p className="text-muted-foreground">
              <TranslationText i18nKey="terms.limitationText">
                In no event shall Subtrackr be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.
              </TranslationText>
            </p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              <TranslationText i18nKey="terms.changes">7. Changes to Terms</TranslationText>
            </h2>
            <p className="text-muted-foreground">
              <TranslationText i18nKey="terms.changesText">
                We reserve the right to update these terms at any time. We will notify users of any material changes via email or through the service.
              </TranslationText>
            </p>
          </div>
          
          <div className="pt-8 border-t">
            <h2 className="text-2xl font-semibold mb-4">
              <TranslationText i18nKey="contactUs">Contact Us</TranslationText>
            </h2>
            <p className="text-muted-foreground">
              <TranslationText i18nKey="termsContactText">
                If you have any questions about these Terms of Service, please contact us at legal@subtrackr.com
              </TranslationText>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
